import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const Conference = ({ post }: IProps) => {
	const linkText = `View Conference`;
	let formattedConferenceStartDate = '';
	let formattedConferenceEndDate = '';
	if (post.conference_date_start) {
		formattedConferenceStartDate = new Date(post.conference_date_start).toLocaleDateString(
			'en-US',
			{
				month: '2-digit',
				day: '2-digit',
				year: '2-digit',
			}
		);
	}
	if (post.conference_date_end) {
		formattedConferenceEndDate = new Date(post.conference_date_end).toLocaleDateString(
			'en-US',
			{
				month: '2-digit',
				day: '2-digit',
				year: '2-digit',
			}
		);
	}

	return (
		<a
			href={post.permalink}
			target="_self"
			rel="noreferrer"
			className="pfa-card-default pfa-card-default--conference"
		>
			{!!post.featured_image && (
				<figure
					className="pfa-card-default__img-wrapper"
					dangerouslySetInnerHTML={{ __html: post.featured_image }}
				/>
			)}
			<div className="pfa-card-default__text">
				{formattedConferenceStartDate && (
					<div className="pfa-card-default__tag-container">
						<p className="pfa-card-default__tag post-tag">
							{post.conference_date_start && formattedConferenceStartDate} -{' '}
							{post.conference_date_end && formattedConferenceEndDate}
						</p>
					</div>
				)}
				<div className="pfa-card-default__content">
					{post.post_title && (
						<h3
							className="pfa-card-default__title"
							dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
						/>
					)}
					{post.conference_location && (
						<p
							className="pfa-card-default__excerpt"
							dangerouslySetInnerHTML={{
								__html: sanitizeHtml(post.conference_location),
							}}
						/>
					)}
				</div>
				<div className="pfa-card-default__link btn-tertiary">
					<div className="btn-frame">
						<span className="btn-inner">{linkText}</span>
					</div>
				</div>
			</div>
		</a>
	);
};

Conference.displayName = 'Conference';

export default Conference;
